import { client, errorValidation } from "./service";

export const getPOList = async function ({
    orderCode, status,
    dateType,
    startDate,
    endDate,
    event,
    customer,
    page,
    limit
}) {
    try {
        let response = await client.get(`/po/list`, {
            params: {
                dateType,
                startDate: startDate || '',
                endDate: endDate || '',
                orderCode,
                status: Array.isArray(status) ? status.join(',') : status,
                event,
                customer,
                page,
                limit
            }
        })
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return errorValidation(e)
    }
}

export const getPODetail = async function ({
    id
}) {
    try {
        let response = await client.get(`/po/detail/${id}`)
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return errorValidation(e)
    }
}

export const addPO = async function ({
    custName, custPhoneNumber, addressDetail, event, discount, products
}) {
    try {
        let response = await client.post(`/po/create`, {
            custName, custPhoneNumber, addressDetail, eventId: event, discount, products
        });
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        // return { error: e.response.data.errorCode }
        return errorValidation(e)
    }
}

export const updatePO = async function ({
    id, 
    custName, custPhoneNumber, addressDetail, products,
    paymentDp, payment, deliver, complete, failed
}) {
    try {
        let response = await client.post(`/po/update/${id}`, {
            custName, custPhoneNumber, addressDetail, products,
            paymentDp, payment, deliver, complete, failed
        });
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        // return { error: e.response.data.errorCode }
        return errorValidation(e)
    }
}

export const updatePOProductStatus = async function ({
    id
}) {
    try {
        let response = await client.put(`/po/update-product-order-buystatus/${id}`);
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        // return { error: e.response.data.errorCode }
        return errorValidation(e)
    }
}

export const deleteJastip = async function ({
    _id
}) {
    try {
        let response = await client.get(`/me/${_id}`);
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        // return { error: e.response.data.errorCode }
        return errorValidation(e)
    }
}